import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {ScaValidationResponseQueryParams} from "@core/shared/models/sca";
import {UserService} from "@core/shared/services/user.service";
import {User} from "@core/shared/models/user";
import {SocietyService} from "@core/shared/services/society.service";
import {SocietyValidationAccount, SocietyValidationAccountOrigin} from "@core/shared/models/society-validation-account";
import {ScaService} from "@core/shared/services/sca.service";

@Component({
    selector: 'app-core-page-sca-validation-response',
    templateUrl: './page-sca-validation-response.component.html',
    styleUrl: './page-sca-validation-response.component.scss',
    standalone: false
})
export class PageScaValidationResponseComponent implements OnInit {

    protected readonly SocietyValidationAccountOrigin = SocietyValidationAccountOrigin;

    public params: ScaValidationResponseQueryParams;

    public societyValidationAccount: Partial<SocietyValidationAccount> = {
        redirectUrl: null
    };

    public constructor(
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
        private _userService: UserService,
        private _societyService: SocietyService,
        private _scaService: ScaService
    ) {}

    ngOnInit() {

        this.params = this._activatedRoute.snapshot.queryParams as ScaValidationResponseQueryParams;

        if(this.params.actionStatus === 'SUCCEEDED'){

            return;
        }

        this._initScaConfiguration();
    }

    private _initScaConfiguration(): void {

        this._societyService.getItemValidationAccountAPI(this.currentUser.society.id).subscribe((item: SocietyValidationAccount): void => {

            Object.assign(this.societyValidationAccount, item);
        });
    }

    public redirectToSca(): void {

        const hasQuery = this.societyValidationAccount.redirectUrl.includes('?');

        const separator: string = hasQuery ? '&' : '?';

        const params: object = {
            returnUrl: this._scaService.getValidationResponseUrl(this.currentUser.locale)
        };

        const paramString: string = Object.entries(params).map(([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`).join('&');

        window.location.href = this.societyValidationAccount.redirectUrl + (paramString ? separator + paramString : '');
    }

    public redirectToDocuments(): void {

        this._router.navigate(['account/service/list'], { queryParams: { targetTab: 'document' } });
    }

    get currentUser(): User {

        return this._userService.currentUser.getValue();
    }
}
